import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import React from "react"
import styles from "./styles"

const DonationQRCode = ({ classes, data, event }) => {
  const qrUrl = `https://event.gives/${event.event_url}/donate`
  const message = "Scan to Donate"

  const qrImage =
    "https://bidr.co/ticket/barcode/barcode.processor.php?encode=QRCODE&bdata=&qrdata_type=text&qr_btext_text=https://event.gives/" +
    event.event_url +
    "/donate&height=500&scale=2&bgcolor=%23ffffff&color=%231B3448&file=&folder&type=png&Genrate=Create+Barcode&ECLevel=L&margin="

  return (
    <div className={classes.container}>
      <div className={classes.qrSection}>
        <div className={classes.qrColumn}>
          <Typography className={classes.message}>{message}</Typography>
          <div className={classes.qrWrap}>
            <div className={classes.qrPlate}>
              <img
                className={classes.qrImage}
                src={qrImage}
                alt="Donation QR code"
              />
            </div>
          </div>
          <Typography className={classes.linkText}>{qrUrl}</Typography>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(DonationQRCode)



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/DonationQRCode/index.jsx